import React from "react";
import "./Menu.css";
import { useTranslation } from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';

export const Menu = ({ onLinkClick }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const scrollOrNavigate = (id) => {
        if (window.location.pathname === '/') {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            navigate('/', { state: { scrollTo: id } });
        }
        if (onLinkClick) onLinkClick();
    };

    return (
        <nav className="menuItemsMobile">
            <div className="itemContainer" onClick={() => scrollOrNavigate('services')}>
                    {t('pages.features')}
            </div>
            <div className="itemContainer" onClick={() => scrollOrNavigate('prices')}>
                    {t('pages.pricing')}
            </div>
            <div className="itemContainer" style={{ whiteSpace: 'nowrap' }} onClick={() => scrollOrNavigate('aboutus')}>
                    {t('pages.company')}
            </div>
            <div className="itemContainer" onClick={() => scrollOrNavigate('faq')}>
                    {t('pages.faq')}
            </div>
        </nav>
    );
};
